import React, { useMemo } from 'react';
import { AddOnCard, AddOnCardProps } from './AddOnCard';
import { AddOnItem, AddOnPrice, AddOnType } from '~/types/models/addon';
import { AddOnDescriptions, AddOnIcons } from '../../../utils';
import { Service } from '~/types/models';

export interface UserAddOnCardProps {
  service?: Service;
  price?: AddOnPrice;
  details?: AddOnItem;
}

export function UserAddOnCard({ details, service }: UserAddOnCardProps) {
  const onCtaClick = () => {
    window.location.href = '/settings/team/edit';
  };

  const onLearnMoreClick = () => {
    window.open(
      'https://help.bonjoro.com/en/articles/569977-inviting-managing-team-members-permissions',
      '_blank',
      'noopener, noreferrer'
    );
  };

  const title = `${
    service == Service.Testimonials ? 'Testimonials' : 'Video messaging'
  } users`;

  const addOnCardProps: AddOnCardProps = useMemo(() => {
    const props: AddOnCardProps = {
      descriptionClassName: 'lg:h-[150px] xl:h-[100px]',
      imgUrl:
        AddOnIcons[AddOnType.TeamMember][service ?? Service.VideoMessaging],
      title,
      description:
        AddOnDescriptions[AddOnType.TeamMember][
          service ?? Service.VideoMessaging
        ],
      billingPrice: '$25',
      billingCycle: '/mo',
      ctaText: 'Add more users',
      onCtaClick,
      onLearnMoreClick,
    };

    if (details?.uuid && details?.quantity) {
      return {
        ...props,
        billingPrice: `${details?.quantity} users added`,
        billingCycle: undefined,
      };
    }

    return props;
  }, [details, service]);

  return <AddOnCard {...addOnCardProps} />;
}
